import { ReactNode } from 'react';
import LeaderboardFiltersModalProvider from '#/leaderboard/contexts/filters/modal';
import LeaderboardVolumeProvider from '#/leaderboard/contexts/volume-provider';
import LeaderboardTabsProvider from '#/leaderboard/contexts/tabs';
import LiquidityFillsProvider from '#/leaderboard/contexts/liquidity-fills-provider';
import LiquidityResponsesProvider from '#/leaderboard/contexts/liquidity-responses-provider';
import LiquidityFilterProvider from '#/leaderboard/contexts/liquidity-filter';

interface Props {
  readonly children: ReactNode;
}

export default function LeaderboardProvider({ children }: Props) {
  return (
    <LeaderboardFiltersModalProvider>
      <LeaderboardVolumeProvider>
        <LiquidityFilterProvider>
          <LiquidityFillsProvider>
            <LiquidityResponsesProvider>
              <LeaderboardTabsProvider>{children}</LeaderboardTabsProvider>
            </LiquidityResponsesProvider>
          </LiquidityFillsProvider>
        </LiquidityFilterProvider>
      </LeaderboardVolumeProvider>
    </LeaderboardFiltersModalProvider>
  );
}
